import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../../components/SEO';
import AppShell from '../../components/AppShell';

/**
 * ComingSoon — shared shell for the areas we're stubbing in Phase 1.
 * Keeps the nav intact and gives each area a distinct voice, so the
 * app feels navigable while the depth is being built.
 */
const ComingSoon = ({
  area, eyebrow, title, body, primaryHref = '/assess', primaryLabel = 'Start my Life Assessment',
  secondaryHref = '/my-life', secondaryLabel = 'Back to My Life', testid,
}) => (
  <AppShell>
    <SEO title={area} description={body} path={`/${area.toLowerCase().replace(/\s+/g, '-')}`} noindex />
    <section className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28 animate-fade-up" data-testid={testid}>
      <p className="eyebrow mb-5">{eyebrow || area}</p>
      <h1
        className="display-serif text-4xl sm:text-5xl mb-5 text-forest text-balance"
        style={{ fontVariationSettings: "'opsz' 96, 'SOFT' 50, 'wght' 360" }}
      >
        {title}
      </h1>
      <p className="text-[17px] sm:text-[19px] text-ink-muted leading-[1.65] max-w-xl mb-10 text-pretty">
        {body}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Link to={primaryHref} className="btn-primary">
          {primaryLabel} <ArrowRight className="w-4 h-4" strokeWidth={2} />
        </Link>
        {secondaryHref && (
          <Link to={secondaryHref} className="btn-secondary">
            {secondaryLabel}
          </Link>
        )}
      </div>
    </section>
  </AppShell>
);

export default ComingSoon;
